import { useEffect, useState } from 'react';

import { Checkbox, DayPicker, Icon, InfoIconTooltip } from '@components';
import { dayOptions } from '@components/payment-collection/constants';
import { Event, sendMixpanelEvent } from '@core/analytics/mixpanel';
import { DayOptionsType } from '@types';

import theme from '../../../../../../themes/colors';

interface AttendanceProps {
  onInputChange: (key: string, value: any) => void;
  className?: string;
  workingDays?: string[];
  isSmsAlertEnabled?: boolean;
  dayOptionClassName?: string;
  required?: boolean;
}

const AttendanceSection = ({
  onInputChange,
  className,
  workingDays,
  isSmsAlertEnabled,
  dayOptionClassName,
  required = false
}: AttendanceProps) => {
  const [selectedDays, setSelectedDays] = useState<string[]>([]);
  const [isSmsAlertActive, setIsSmsAlertActive] = useState<boolean>(false);

  const handleDayChange = (days: DayOptionsType[]) => {
    const daysArray = days.map((day) => day.value);
    setSelectedDays(daysArray);
    onInputChange('workingDays', daysArray);
    sendMixpanelEvent(Event.ATTENDANCE_DAYS_CLICKED, {
      attendance_selected_days: daysArray
    });
  };

  const markedDays = dayOptions.filter((dayOption) =>
    selectedDays.includes(dayOption.value)
  );

  const handleSmsAlertToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsSmsAlertActive(e.target.checked);
    onInputChange('isSendAttendanceAlertEnabled', e.target.checked);
    sendMixpanelEvent(Event.ATTENDANCE_SMS_ALERT_CLICKED, {
      sms_alert_enabled: e.target.checked
    });
  };

  useEffect(() => {
    setIsSmsAlertActive(!!isSmsAlertEnabled);
  }, [isSmsAlertEnabled]);

  useEffect(() => {
    setSelectedDays(workingDays || []);
  }, [workingDays]);

  return (
    <div className={`mt-8 ${className}`}>
      <p className="text-base font-semibold text-cofeeNeutral10">
        Working Days {required && <span className="text-error">*</span>}
      </p>
      <div className="mb-3 flex items-center gap-0.5">
        <Icon name="alert-circle" stroke={theme.cofeeGreyBlue8} />
        <span className="text-sm text-cofeeNeutral7">
          Select days when attendance can be marked
        </span>
      </div>
      <DayPicker
        onChange={handleDayChange}
        markedDays={markedDays}
        dayOptionClassName={dayOptionClassName}
      />
      <div className="flex items-center gap-2">
        <Checkbox
          handleChange={handleSmsAlertToggle}
          label="Notify Absentees"
          isChecked={isSmsAlertActive}
          disabled={selectedDays.length === 0}
        />
        <InfoIconTooltip
          tooltipText="An attendance alert will be sent to members who are absent."
          id="create-grp-absent-alert"
        />
      </div>
    </div>
  );
};

export default AttendanceSection;
